import { apiUrl } from './../constants/apiUrl';
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../service/logService';
import { redirectTo } from './redirection';
import { Utils } from '../util/utils';
import { Pages } from '../constants/actionType';
import api from '../service/apiService';
import { getVZDLInit } from '../service/vzdl';

let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;

export const errorAction = (error, page, errorMessage, logName, cookieVal, dispatch, isQueryStringLBO, QueryString) => {
  try {
    logOtherInfo(detailsInfo('AccessoriesHome', cookieVal, 'getbannerFromAPI', 'Inside getbannerFromAPI'));
    if (cookieVal === '') cookieVal = 'VisitIdEmpty';
    logKafka(error, page, errorMessage, getErrorLogUrl, logName, cookieVal);
    if (isQueryStringLBO && error !== 'MON-400') {
      if (window.location.search.toLowerCase().indexOf('productnotreturned') < 0) {
        let lboUrl = Pages.LBO + '?Message=' + QueryString;
        dispatch({
          type: 'LBO',
          value: errorMessage,
          frompage: page,
          error: error,
        });
        redirectTo(lboUrl, dispatch);
      }
    } else if (error === 'LBO' && window.location.search.toLowerCase().indexOf('productnotreturned') < 0) {
      redirectTo(Pages.LBO, dispatch);
    } else if (error === 'MON-400') {
      Utils.clearMemory();
      redirectTo(Pages.CheckLQ + '?Message=' + QueryString, dispatch);
    }
    if (error) {
      dispatch({
        type: 'LBO',
        value: errorMessage,
        frompage: page,
        error: error,
      });
    }
  } catch (ex) {
    let errorMsg = `MethodName:getbannerFromAPI,errorMessage:${error.message}`;
    logKafka('ERROR', 'AccessoriesHome', errorMsg, getErrorLogUrl, 'applogs', cookieVal);
    catchJSException('error', cookieVal, 'action_errorAction', ex);
  }
};

export const clientException = (dispatch, errorDetails) => {
  //Log Page Level Kafka Issue  here
  //logKafka(error,page,errorMessage,getErrorLogUrl,logName,cookieVal);
  dispatch({
    type: 'CLIENT_EXCEPTION',
    value: errorDetails,
  });
};

export const logout = (dispatch) => {
  dispatch({ type: 'CLEAR_STORE' });
  redirectTo(Pages.CheckLQ, dispatch);
};
export const logoutSmartSave = (dispatch, mon) => {
  dispatch({ type: 'CLEAR_STORE' });
  redirectTo(Pages.ResumeCart + '?xpsid=' + mon + '&ordertype=SmartSave&XpsSource=SaveOverlay', dispatch);
};

export const logOutVendorFlow = (dispatch) => {
  dispatch({ type: 'CLEAR_STORE' });
};

export const getBillPunchOutErrors = (dispatch, visitId) => {
  try {
    logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getBillPunchOutErrors', 'Inside getBillPunchOutErrors'));

    return new Promise((resolve, reject) => {
      const vtpErrorsUrl = apiUrl().vtpErrors;
      var requestInfo = {
        apiName: 'BILL_PUNCHOUT',
        errorCodes: ['12005', '3D_MAX', 'VEPS_MAX', '12020', '1050', '201'],
      };
      let request = JSON.stringify(requestInfo);
      api(vtpErrorsUrl, 'POST', request)
        .then((response) => {
          if (Utils.isNotNull(response)) {
            let modifiedResponse = {};
            response.forEach((element) => {
              modifiedResponse['_' + element.errorCode] = element;
            });
            dispatch({ type: 'BILLPUNCHOUTERRORS', value: modifiedResponse });
            resolve(true);
          }
        })
        .catch((error) => {
          let errorMsg = `MethodName:getBillPunchOutErrors,errorMessage:${error.message}`;
          logKafka('ERROR', 'AccessoriesHome', errorMsg, getErrorLogUrl, 'applogs', visitId);
          getVZDLInit(visitId, '', '', '', '', '', '', error.message);
        });
    });
  } catch (ex) {
    catchJSException('AccessoriesHome', visitId, 'getBillPunchOutErrors', ex);
  }
};

export const getBillingAddressValidationErrors = (dispatch, visitId) => {
  try {
    logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getBillingAddressValidationErrors', 'Inside getBillingAddressValidationErrors'));
    return new Promise((resolve, reject) => {
      const vtpErrorsUrl = apiUrl().vtpErrors;
      var requestInfo = {
        apiName: 'BILLINGADDRESS_VALIDATION',
        errorCodes: ['12004'],
      };
      let request = JSON.stringify(requestInfo);
      api(vtpErrorsUrl, 'POST', request)
        .then((response) => {
          if (Utils.isNotNull(response)) {
            let modifiedResponse = {};
            response.forEach((element) => {
              modifiedResponse['_' + element.errorCode] = element;
            });
            dispatch({ type: 'BILLINGADDRESSVALIDATIONERRORS', value: modifiedResponse });
            resolve(true);
          }
        })
        .catch((error) => {
          let errorMsg = `MethodName:getBillingAddressValidationErrors,errorMessage:${error.message}`;
          logKafka('ERROR', 'AccessoriesHome', errorMsg, getErrorLogUrl, 'applogs', visitId);
          getVZDLInit(visitId, '', '', '', '', '', '', error.message);
        });
    });
  } catch (ex) {
    catchJSException('AccessoriesHome', visitId, 'getBillingAddressValidationErrors', ex);
  }
};

export const getVzProfileErrors = (dispatch, visitId) => {
  try {
    logOtherInfo(detailsInfo('AccessoriesHome', visitId, 'getVzProfileErrors', 'Inside getVzProfileErrors'));
    return new Promise((resolve, reject) => {
      const vtpErrorsUrl = apiUrl().vtpErrors;
      var requestInfo = {
        apiName: 'GET_VZ_FULL_PROFILE',
        errorCodes: ['PreProvisionedOrderExists', 'OnlyVoiceOrderExists'],
      };
      let request = JSON.stringify(requestInfo);
      api(vtpErrorsUrl, 'POST', request)
        .then((response) => {
          if (Utils.isNotNull(response)) {
            let modifiedResponse = {};
            response.forEach((element) => {
              modifiedResponse['_' + element.errorCode] = element;
            });
            dispatch({ type: 'VZPROFILEERRORS', value: modifiedResponse });
            resolve(true);
          }
        })
        .catch((error) => {
          let errorMsg = `MethodName:getVzProfileErrors,errorMessage:${error.message}`;
          logKafka('ERROR', 'AccessoriesHome', errorMsg, getErrorLogUrl, 'applogs', visitId);
          getVZDLInit(visitId, '', '', '', '', '', '', error.message);
        });
    });
  } catch (ex) {
    catchJSException('AccessoriesHome', visitId, 'getVzProfileErrors', ex);
  }
};
